import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { agentPreviewsQueryKey } from "../user.keys";

export const useFetchAgentPreviews = () => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: agentPreviewsQueryKey(),
		queryFn: async () => await get<Dtos.Agent.Preview.Get.Response[]>(`/v2/agents/previews`),
		retry: false,
		staleTime: 1000 * 60 * 60 * 24 * 7,
		gcTime: 1000 * 60 * 60 * 24 * 7,
	});

	return { agentPreviews: data, agentPreviewsError: error, agentPreviewsLoading: isLoading };
};
